import axios from 'axios';
import { ApiLink } from '../APILink/ApiLink';
import authHeader from '../Auth/authHeader';
import { errorAlert } from '../Components/Alerts';

export const getCompanyVatDeclarant = async (headers) => {
    try {
        const response = await axios.get(ApiLink.API_URL + 'PersonalData', { headers });

        const vatDeclarant = response.data?.[0]?.VATDeclarant;
        // alert(vatDeclarant);

        // Kontrollo që është 0 ose 1 përpara konvertimit
        return vatDeclarant;
    } catch (error) {
        errorAlert("Gabim në kërkesë:", error);

        if (error.response?.data?.errorMessage) {
            errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
        } else if (error.message) {
            errorAlert(`Gabim: ${error.message}`);
        } else {
            errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
        }

        return null; // Kthe null në rast gabimi që mos prishet përdorimi në skedarë tjerë
    }
};

export const getAllMyCompanyData = async () => {
    const headers = authHeader();
    try {
        const response = await axios.get(
            `${ApiLink.API_URL}Companies/getCompanyDetails`,
            { headers }
        );
        return response.data;
    } catch (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.errorMessage
        ) {
            throw new Error(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
        } else if (error.message) {
            throw new Error(`Gabim: ${error.message}`);
        } else {
            throw new Error("Gabim i panjohur në kërkesë.");
        }
    }
};

// Merr detajet e llogarive bankare
export const getMyCompanyBanks = async () => {
    const headers = authHeader();
    try {
        const response = await axios.get(
            `${ApiLink.API_URL}Accounts/BankDetails`,
            { headers }
        );
        return response.data;
    } catch (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.errorMessage
        ) {
            throw new Error(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
        } else if (error.message) {
            throw new Error(`Gabim: ${error.message}`);
        } else {
            throw new Error("Gabim i panjohur në kërkesë.");
        }
    }
};